import { Command as CommandPrimitive } from 'cmdk';
import type { ComponentPropsWithoutRef, ComponentRef, Ref } from 'react';

/**
 * Represents a command component.
 */
export const Command = ({
  className,
  ref,
  ...props
}: ComponentPropsWithoutRef<typeof CommandPrimitive> & {
  ref?: Ref<ComponentRef<typeof CommandPrimitive>>;
}) => (
  <CommandPrimitive
    onClick={(e) => {
      e.stopPropagation();
      e.preventDefault();
    }}
    ref={ref}
    className={className}
    {...props}
  />
);

Command.displayName = CommandPrimitive.displayName;
